import type { FC } from 'react'

import {
  type ChildrenClasses,
  type ChildrenProps,
  type DefaultComponent,
  useCustomRendering,
} from '../customise/index.js'
import defaultStyles from './Children.module.scss'

const DefaultRenderer: DefaultComponent<ChildrenProps, ChildrenClasses> = ({
  styles,
  children,
}) => {
  return <div className={styles.children}>{children}</div>
}

export const Children: FC<ChildrenProps> = (props) => {
  const ResolvedRenderer = useCustomRendering<ChildrenProps, ChildrenClasses>(
    'Children',
    defaultStyles,
    DefaultRenderer
  )
  return <ResolvedRenderer {...props} />
}
